import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerModalComponent } from 'src/app/shared/components/others/spinner-modal/spinner-modal.component';
import { ColDef } from 'ag-grid-community';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { SelectorComponent } from 'src/app/shared/components/sqp-components/sqpSelectores/components/selector/selector.component';
import { DatosExcel } from 'src/app/shared/ExportadorFicheros/models/datos-excel';
import { DatosPdf } from 'src/app/shared/ExportadorFicheros/models/datos-pdf';
import { ExportadorExcelService } from 'src/app/shared/ExportadorFicheros/services/exportador-excel.service';
import { ExportadorPdfService } from 'src/app/shared/ExportadorFicheros/services/exportador-pdf.service';
import { FiltroEnvio } from 'src/app/shared/models/filtros';
import { GridColDefsEnvios } from 'src/app/pages/configuracion/Envios/envios/models/grid-col-defs-envios';
import { EstadosTipoEnvio, TipoEnvio } from '../../models/tipo-envio';
import { DatosEnviosService } from '../../services/datos-envios.service';
import { EnviosBarraSuperiorComponent } from '../envios-barra-superior/envios-barra-superior.component';
import { Firmantes } from '../../models/firmantes';
import { Location } from '@angular/common';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { TipoFiltro } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/tipo-filtro';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';

@Component({
  selector: 'app-envios-page',
  templateUrl: './envios-page.component.html',
  styleUrls: ['./envios-page.component.css']
})
export class EnviosPageComponent implements OnInit, OnDestroy {

  envios: TipoEnvio[] = [];
  textoBuscar: string = '';
  filtros: FiltroEnvio[] = [];
  @ViewChild(EnviosBarraSuperiorComponent) barrSuperior!: EnviosBarraSuperiorComponent;
  verIncompletos: boolean = false;
  @ViewChild(SelectorComponent) selector!: SelectorComponent;
  columnDefs: ColDef[] = new GridColDefsEnvios().columnDefs;
  gridOptions:any = {
    getRowStyle: (params:any) => {
      // if(params.data.estado === EstadosTipoEnvio.incompleto) {
      if(params.data.activo === false) {
        return {'font-weight':700}
      }
      return {'font-weight':400}
    },
    suppressScrollOnNewData: true
  }
  resetEnvios: TipoEnvio[];
  isLoading: boolean = false;
  spinnerDialogRef: any;

  filtrosSqpEnvios: FiltroSqp[] = [];
  currentPage: number = 1;
  hasMoreRows: boolean = true;
  ordenColumna: OrdenColumna;


  constructor(public datosEnviosService: DatosEnviosService,
              private dialog: MatDialog,
              private exportadorPdfService: ExportadorPdfService,
              private exportadorExcelService: ExportadorExcelService,
              private router: Router,
              private location: Location,
              private activatedRoute: ActivatedRoute) {

              }

  ngOnInit() {
    if(this.router.url.includes('incompletos')){
      this.verIncompletos = true;
      this.filtros.push({
        text: 'Estado',
        textoBuscar: '',
        value: 'Incompleto',
        estado: 'Incompleto',
        idTipoEnvio: ''
      })
      this.refreshData('filtros Incompletos');
      this.location.replaceState('/panel/dosieres-configurados');
    }else{
      this.refreshData('filtros Incompletos');
    }
  }

  async getEnviosData(){
    if (this.isLoading || !this.hasMoreRows) return;
    this.isLoading = true;
    this.spinnerDialogRef = this.dialog.open(SpinnerModalSqpComponent);

    try {
      await this.datosEnviosService.getTipoEnvios(this.filtros, this.currentPage, 200, this.ordenColumna);
      this.envios = [...(this.envios || []), ...this.datosEnviosService.enviosFiltrados];
      this.currentPage++;
      const returnedRowCount = this.datosEnviosService.enviosFiltrados.length;
      if (returnedRowCount < 200) {
        this.hasMoreRows = false;
      }else this.hasMoreRows = true;

    } catch (error) {
      console.error('Error loading rows:', error);
    } finally {
      this.isLoading = false;
      if (this.spinnerDialogRef) {
        this.spinnerDialogRef.close();
      }
    }
  }

  ngOnDestroy() {
    // Clean up spinner if component is destroyed while loading
    if (this.spinnerDialogRef) {
      this.spinnerDialogRef.close();
    }
  }

  //#region Acciones barra superior

  clickBarraSuperior(id: string){
    switch (id) {
      case 'Excel':
        this.exportaExcel();
        break;
      case "Pdf":
        this.exportaPdf();
        break;
      default:
        break;
    }
  }

  configuraNuevoEnvio(){
    this.router.navigate(['/panel/configuracion-dosier/0']);
  }

  exportaPdf(){
    if(this.envios){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-pdf-empty',
          titulo: 'Generar PDF',
          mensaje: 'Genera un documento PDF con la información de los registros mostrados en el listado',
          textoConfirmacion: 'Generar PDF',
          iconoConfirmacion: 'icon-pdf-empty',
          textoCancelar: 'cancelar'
        }
      });

      //montamos el objeto a pasar al servicio con el modelo DatosPdf
      const datos = this.montarParametrosPdf();

      dialogRef.afterClosed().subscribe(async result => {
        if(result === 'OK'){
          const dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
          if(this.hasMoreRows){
            await this.datosEnviosService.getTipoEnvios(this.filtros, 0, 0, this.ordenColumna);
            this.envios = [...this.datosEnviosService.enviosFiltrados];
          }
          let arrayPdf: any[] = [];
          this.envios.forEach(x=>{
            let objetoPdf = {} as any;
            let validadoresArray = x.firmantes.filter((x: Firmantes) => x.tipoDestinatario.desc == 'Validador');
            x.validadores = validadoresArray.length;
            if(x.activo == true) x.estado = EstadosTipoEnvio.completo
            else x.estado = EstadosTipoEnvio.incompleto

            objetoPdf.nombre = x.nombre;
            objetoPdf.tiposDocumento = x.tiposDocumento.length;
            objetoPdf.firmantes = x.firmantes.length;
            objetoPdf.validadores = x.validadores;
            objetoPdf.estado = x.estado

            arrayPdf.push(objetoPdf);
          })
          this.exportadorPdfService.exportaPdf(datos, arrayPdf)
          dialogRefSpinner.close();
          this.hasMoreRows = false;
        }
      });
    }
  }

  montarParametrosPdf(): DatosPdf{
    let columns: any [] = [];
    this.columnDefs.forEach( x => {
      columns.push( {header: x.headerName, dataKey: x.field} )
    })
    let fecha = new Date();
    let datosPdf = {
      landscape: true,
      nombreFichero:`Hire&Sign_dosieres_configurados_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.pdf`,
      registros: columns
    }
    return datosPdf
  }

  exportaExcel(){
    if(this.envios){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-excel-empty',
          titulo: 'Generar excel',
          mensaje: 'Genera un documento Excel con la información de los registros mostrados en el listado',
          textoConfirmacion: 'Generar excel',
          iconoConfirmacion: 'icon-excel-empty',
          textoCancelar: 'cancelar'
        }
      });

      let datosExcel = this.montarParametrosExcel();

      dialogRef.afterClosed().subscribe(async result => {
        if(result === 'OK'){
          const dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
          if(this.hasMoreRows){
            await this.datosEnviosService.getTipoEnvios(this.filtros, 0, 0, this.ordenColumna);
            this.envios = [...this.datosEnviosService.enviosFiltrados];
          }
          let rows = this.GetRows(this.envios);
          this.exportadorExcelService.exportaExcel(datosExcel, rows);
          dialogRefSpinner.close();
          this.hasMoreRows = false;
        }
      });
    }
  }

  montarParametrosExcel(): DatosExcel{
    let fecha = new Date();
    let datosExcel = {
      workSheetName:'Dosieres',
      nombreFichero:`Hire&Sign_dosieres_configurados_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.xlsx`,
      columnas: this.GetColumns()
    }
    return datosExcel
  }

  GetColumns(): any[]{
    let columns:any[] = [];
    this.columnDefs.forEach( x => {
        let element:any = {};
        element.name = x.headerName;
        element.filterButton = true;
        element.width = x.width;
        columns.push(element);
    });
    return columns;
  }

  GetRows(data: TipoEnvio[]): any{
    let rows:any[] = [];
    data.forEach(x=>{
      let validadoresArray = x.firmantes.filter((x: Firmantes) => x.tipoDestinatario.desc == 'Validador');
      x.validadores = validadoresArray.length;
      if(x.activo == true) x.estado = EstadosTipoEnvio.completo
      else x.estado = EstadosTipoEnvio.incompleto
      let row:any[] =
      [
        x.nombre,
        x.tiposDocumento.length,
        x.firmantes.length,
        x.validadores,
        x.estado
      ];
      rows.push(row);
    });
    return rows
  }

  buscarEnvios(textoBuscar: string){
    if(this.datosEnviosService.enviosFiltrados){
      let filtroTexto: FiltroEnvio = {
        textoBuscar: textoBuscar,
        text: 'Texto',
        value: textoBuscar,
        idTipoEnvio: "",
        estado:''
      };
      let index = this.filtros.findIndex(x=>x.text=='Texto')
      if(index == -1) this.filtros.push(filtroTexto);
      else this.filtros[index] = filtroTexto;
      this.refreshData('filtros Buscador');
    }
  }

  getIncompleto(event:boolean){
    if(event==true) this.verIncompletos = true;
  }

  abrirDetalleDosier(event: any){
    let envio: TipoEnvio = event.data;
    // this.router.navigate([`/panel/configuracion-dosier/${envio.idTipoEnvio}`])
    this.router.navigate([`/panel/configuracion-dosier/${envio.idV3TipoEnvio}`])
  }

  loadRows(){
    if (this.isLoading || !this.hasMoreRows) return;
    this.getEnviosData();
  }

  ordenarGrid(event: OrdenColumna){
    this.ordenColumna = event;
    this.refreshData('ordenar')
  }

  refreshData(origen?:string){
    this.currentPage = 1;
    this.datosEnviosService.enviosFiltrados = [];
    this.envios = [];
    this.hasMoreRows = true;
    this.getEnviosData();
  }

  actualizarFiltrosDesdeFiltroSuperior(event:FiltroEnvio){
    if(event){ //el evento puede venir undefined cuando se hace limpiar todo
      let index = this.filtros.findIndex(x=>x.text==event.text)
      if(index == -1) this.filtros.push(event);
      else this.filtros[index] = event;
    }
    this.refreshData('filtros');
  }

}
